import styles from '../PlanCard.module.scss';

interface DisabledTooltipProps {
  id: string;
  message: string;
  horizontalAlignment?: 'center' | 'left';
  verticalAlignment?: 'top' | 'bottom';
}

export default function DisabledTooltip({
  id,
  message,
  horizontalAlignment = 'center',
  verticalAlignment = 'top',
}: DisabledTooltipProps) {
  return (
    <span
      id={id}
      className={`${styles.disabledTooltip}${
        horizontalAlignment === 'left' ? ` ${styles.disabledTooltipLeft}` : ''
      }${
        verticalAlignment === 'bottom' ? ` ${styles.disabledTooltipBottom}` : ''
      }`}
    >
      {message}
    </span>
  );
}
